<template>
  <div class="grid pb-0">
    <div class="grid-title d-flex">
      <h4>{{ $t("BOOKING_LIST") }}</h4>
      <div class="d-flex">
        <div class="mr-3 d-flex align-items-end">
        <v-btn outlined @click="exportBooking" color="success">
          <i class="icon-Excel fs-20"></i>
          {{ $t("_BOOKING.EXPORT") }}
        </v-btn>
      </div>
      <div class="mr-3 d-flex align-items-end">
        <v-btn outlined @click="exportBookingPdf" color="error">
          <i class="icon-picture_as_pdf fs-20"></i>
          {{ $t("_BOOKING.PDF") }}
        </v-btn>
      </div>
      <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" text outlined>
            <i class="icon-table_chart fs-20 mr-1"></i> {{ $t('SHOW_MORE') }}
          </v-btn>
        </template>

        <v-card min-width="300">
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>{{ $t('SHOW_MORE') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <b-form-input v-model="textSearch" :placeholder="$t('_HOTEL_CHAIN.SEARCH')"></b-form-input>
            </v-list-item>
            <v-list-item>
              <p class=" mt-1 mb-0">
                <a class="text-primary" @click="selectAllColum()">{{
                  $t('SELECT_ALL') }} | </a> <a class="text-primary" @click="columViews = []">{{ $t('UN_SELECT_ALL')}}</a>
              </p>
            </v-list-item>
          </v-list>
          <v-list class="pt-0" style="max-height: 400px; overflow-y: auto">
            
            <v-list-item >
              <b-form-group v-slot="{ ariaDescribedby }">
                <b-form-checkbox-group v-model="columViews"
                  :options="colums.filter(item => item.text.toString().toLowerCase().includes(textSearch.toLowerCase()))"
                  :aria-describedby="ariaDescribedby" name="flavour-2a" stacked></b-form-checkbox-group>
              </b-form-group>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
      </div>
    </div>
    <div class="grid-body list-booking-group">
      <div class="p-3">
        <div class="search-box">
          <v-btn @click="searchByCode()" outlined class="search-icon-left">
          <svg focusable="false" height="24px" viewBox="0 0 24 24" width="24px" xmlns="http://www.w3.org/2000/svg">
              <path d="M20.49,19l-5.73-5.73C15.53,12.2,16,10.91,16,9.5C16,5.91,13.09,3,9.5,3S3,5.91,3,9.5C3,13.09,5.91,16,9.5,16 c1.41,0,2.7-0.47,3.77-1.24L19,20.49L20.49,19z M5,9.5C5,7.01,7.01,5,9.5,5S14,7.01,14,9.5S11.99,14,9.5,14S5,11.99,5,9.5z"></path><path d="M0,0h24v24H0V0z" fill="none"></path>
          </svg>
          </v-btn>
          <input v-model="bookingCodeSearch" @keyup.enter="searchByCode()" type="text" :placeholder="$t('_BOOKING.ENTER_BOOKING_CODE_OTA')" />
          <v-btn outlined @click="openPopup()" class="search-icon-right">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"></path></svg>
          </v-btn>
        </div>
        <!-- start -->
        <div class="overlay-search" @click="openPopup()" v-if="isShowPopup"></div>
        <div class="popup-search p-3" v-if="isShowPopup">
          <div class="popup-content">
            <b-row>
                <b-col md="6">
                    <label>
                        {{
                            $t("_BOOKING.SEARCH_CONDITION")
                        }}
                    </label>
                    <v-select outlined dense item-text="text" item-value="value"
                        :items="listSearchCondition" v-model="selectedSearchCondition" class="w-100" />
                </b-col>
                <b-col md="6"
                    v-if="selectedSearchCondition === 'BOOKING_CODE' || selectedSearchCondition === 'BOOKING_CODE_OTA'">
                    <label>{{
                        $t("_BOOKING.SEARCH_BOOKING_CODE")
                    }}</label>
                    <v-text-field v-model="paging.code" dense outlined class="w-100"></v-text-field>
                </b-col>
                <b-col md="6" v-if="selectedSearchCondition === null ||
                    selectedSearchCondition === 'BOOKING_DATE' ||
                    selectedSearchCondition === 'CHECKIN_DATE' ||
                    selectedSearchCondition === 'CHECKOUT_DATE'
                    ">
                    <label>{{
                        $t("_BOOKING.SEARCH_DATE")
                    }}</label>
                    <div class="d-flex justify-content-between">
                        <date-picker :confirm-text="$t('CONFIRM')" :clearable="false"
                        :type="selectedSearchCondition === 'BOOKING_DATE' ? 'datetime' : 'date'"
                            :popup-class="'popup-calendar-desktop-detailhotel'" v-model="dateRange"
                            :lang="languageDate" 
                            :format="selectedSearchCondition === 'BOOKING_DATE' ? 'DD/MM/YYYY HH:mm:ss' : 'DD/MM/YYYY'" :editable="false" :shortcuts=[]
                            range placeholder="Select date range">
                        </date-picker>
                    </div>
                </b-col>
                <b-col md="6" v-if="selectedSearchCondition === 'STAY_DATE'">
                    <label>{{
                    $t("_BOOKING.SEARCH_BY.STAYING_DATE")
                    }}</label>
                    <div class="d-flex justify-content-between">
                    <date-picker :confirm-text="$t('CONFIRM')" :clearable="false"
                        :popup-class="'popup-calendar-desktop-detailhotel'" v-model="stayDate" :lang="languageDate"
                        :format="'DD/MM/YYYY'" :editable="false" :shortcuts=[] :range="false" placeholder="Select date">
                    </date-picker>
                    </div>
                </b-col>
            </b-row>
            <b-row>
              <b-col md="6" class="pt-0 pr-0">
                    <label>{{
                        $t("BOOKING_CHANNEL")
                    }}</label>
                    <v-autocomplete dense outlined item-text="text" item-value="value"
                        :items="listSelectOTA" v-model="selectedOTA" chips multiple ref="selectChannelBk">
                        <template v-slot:prepend-item>
                            <p class="mx-3 mt-1"> <a class="text-primary"
                                @click="selectedOTA = [...new Set(selectedOTA.concat($refs['selectChannelBk'].filteredItems.map(e => e.value)))]">{{ $t('SELECT_ALL') }}</a> | <a
                                class="text-primary" @click="selectedOTA = []">{{ $t('UN_SELECT_ALL') }}</a>
                            </p>
                        </template>

                        <template v-slot:selection="{ item, index }">
                            <v-chip color="primary" v-if="index === 0" v-bind="item.attrs" :input-value="item.selected" close
                                @click:close="remove(index, selectedOTA)" @click="item.select">
                                <p class="mb-0 text-truncate" style="max-width: 150px">{{ item.text }}</p>
                            </v-chip>
                            <span v-if="index === 1" class="grey--text caption">(+{{ selectedOTA.length - 1 }})</span>
                        </template>
                        <template slot="no-data">
                                <div class="no-data">{{ $t("NO_DATA") }}</div>
                        </template>
                    </v-autocomplete>
                </b-col>
                <b-col md="6" class="py-0">
                  <label>{{ $t("BOOKING_HOTEL") }}</label>
                  <v-autocomplete chips dense multiple outlined item-text="text" item-value="value" :items="listSelectHotel"
                    v-model="selectedHotel" ref="selectHotelBk">
                    <template v-slot:prepend-item>
                      <p class="mx-3 mt-1"> <a class="text-primary"
                          @click="selectedHotel = [...new Set(selectedHotel.concat($refs['selectHotelBk'].filteredItems.map(e => e.value)))]">{{ $t('SELECT_ALL') }}</a> | <a
                          class="text-primary" @click="selectedHotel = []">{{ $t('UN_SELECT_ALL') }}</a>
                      </p>
                    </template>

                    <template v-slot:selection="{ item, index }">
                      <v-chip color="primary" v-if="index === 0" v-bind="item.attrs" :input-value="item.selected" close
                        @click:close="remove(index, selectedHotel)" @click="item.select">
                        <p class="mb-0 text-truncate" style="max-width: 150px">{{ item.text }}</p>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text caption">(+{{ selectedHotel.length - 1 }})</span>
                    </template>
                    <template slot="no-data">
                      <div class="no-data">{{ $t("NO_DATA") }}</div>
                    </template>
                  </v-autocomplete>
                </b-col>
            </b-row>
            <b-row>
              <b-col md="6" class="pt-0 pr-0">
                    <label>{{ $t("_BOOKING_TRANSACTION.BOOKING_STATUS") }}</label>
                    <v-autocomplete dense outlined item-text="text" item-value="value"
                        :items="listBookingStatus" v-model="selectedBookingStatus" chips multiple ref="bkStatusbk">
                        <template v-slot:prepend-item>
                            <p class="mx-3 mt-1"> <a class="text-primary"
                                @click="selectedBookingStatus = [...new Set(selectedBookingStatus.concat($refs['bkStatusbk'].filteredItems.map(e => e.value)))]">{{ $t('SELECT_ALL') }}</a> | <a
                                class="text-primary" @click="selectedBookingStatus = []">{{ $t('UN_SELECT_ALL') }}</a>
                            </p>
                        </template>

                        <template v-slot:selection="{ item, index }">
                            <v-chip color="primary" v-if="index === 0" v-bind="item.attrs" :input-value="item.selected" close
                                @click:close="remove(index, selectedBookingStatus)" @click="item.select">
                                <p class="mb-0 text-truncate" style="max-width: 150px">{{ item.text }}</p>
                            </v-chip>
                            <span v-if="index === 1" class="grey--text caption">(+{{ selectedBookingStatus.length - 1 }})</span>
                        </template>
                        <template slot="no-data">
                                <div class="no-data">{{ $t("NO_DATA") }}</div>
                        </template>
                    </v-autocomplete>
                </b-col>
                <b-col md="6" class="py-0">
                  <label>
                    {{ $t("_BOOKING.SEARCH_PMS_STATUS") }}
                  </label>
                  <v-autocomplete outlined dense item-text="text" item-value="value" :items="listSearchPmsStatus"
                    v-model="selectedSearchPmsStatus">
                  </v-autocomplete>
                </b-col>
            </b-row>
            <b-row>
              <b-col md="6" class="pt-0 pr-0">
                <label>
                  {{ $t("_BOOKING.SEARCH_PMS_CODE") }}
                </label>
                <v-autocomplete chips dense multiple outlined item-text="text" item-value="value" :items="listSearchPmsCode"
                  v-model="selectedSearchPmsCode" ref="pmsCodeBk">
                  <template v-slot:prepend-item>
                    <p class="mx-3 mt-1"> <a class="text-primary"
                        @click="selectedSearchPmsCode = [...new Set(selectedSearchPmsCode.concat($refs['pmsCodeBk'].filteredItems.map(e => e.value)))]">{{ $t('SELECT_ALL') }}</a> | <a
                        class="text-primary" @click="selectedSearchPmsCode = []">{{ $t('UN_SELECT_ALL') }}</a>
                    </p>
                  </template>

                  <template v-slot:selection="{ item, index }">
                    <v-chip color="primary" v-if="index === 0" v-bind="item.attrs" :input-value="item.selected" close
                      @click:close="remove(index, selectedSearchPmsCode)" @click="item.select">
                      <span>{{ item.text }}</span>
                    </v-chip>
                    <span v-if="index === 1" class="grey--text caption">(+{{ selectedSearchPmsCode.length - 1 }})</span>
                  </template>
                  <template slot="no-data">
                    <div class="no-data">{{ $t("NO_DATA") }}</div>
                  </template>
                </v-autocomplete>
              </b-col>
                <b-col md="6" class="pt-0">
                    <label>{{
                        $t("SEARCH_BY_BOOKER")
                    }}</label>
                    <v-text-field v-model="customerName" dense outlined></v-text-field>
                </b-col>
            </b-row>
            <b-row>
              <b-col md="6" class="pt-0 pr-0">
                <label>{{ $t("CUSTOMER_PHONE") }}</label>
                <v-text-field v-model="customerPhone" dense outlined></v-text-field>
              </b-col>
              <b-col md="6" class="pt-0">
                <label>{{ $t('NAME_OF_GUEST_STAYING') }}</label>
                <v-text-field v-model="customerNameStay" dense outlined></v-text-field>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6" class="pt-0 pr-0">
                <label>{{ $t("CREATED_BY_ACCOUNT") }}</label>
                <v-text-field v-model="createdByName" dense outlined></v-text-field>
              </b-col>
              <b-col md="6" class="pt-0">
                <label>{{ $t("UTM_CODE") }}</label>
                <v-text-field v-model="utmCode" dense outlined></v-text-field>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6" class="pt-0 pr-0">
                <label>{{ $t("_BOOKING.AGENT") }}</label>
                <v-autocomplete outlined chips dense multiple item-text="title" item-value="travelAgentCode" :items="agents"
                    v-model="bookingTravelAgent" ref="agentBk">
                    <template v-slot:prepend-item>
                      <p class="mx-3 mt-1"> <a class="text-primary"
                          @click="bookingTravelAgent = [...new Set(bookingTravelAgent.concat($refs['agentBk'].filteredItems.map(e => e.travelAgentCode)))]">{{ $t('SELECT_ALL') }}</a> | <a
                          class="text-primary" @click="bookingTravelAgent = []">{{ $t('UN_SELECT_ALL') }}</a>
                      </p>
                    </template>

                    <template v-slot:selection="{ item, index }">
                      <v-chip color="primary" v-if="index === 0" v-bind="item.attrs" :input-value="item.selected" close
                        @click:close="remove(index, bookingTravelAgent)" @click="item.select">
                        <span>{{ item.title }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text caption">(+{{ [...new Set(bookingTravelAgent)].length - 1 }})</span>
                    </template>
                    <template slot="no-data">
                      <div class="no-data">{{ $t("NO_DATA") }}</div>
                    </template>
                  </v-autocomplete>
              </b-col>
              <b-col md="6" class="pt-0">
                <label>{{ $t('_BOOKING.MARKET') }}</label>
                <v-autocomplete outlined chips dense multiple item-text="name" item-value="code" :items="segments"
                  v-model="bookingMarketSegment" ref="bookingMarketSegment">
                  <template v-slot:prepend-item>
                    <p class="mx-3 mt-1"> <a class="text-primary"
                        @click="bookingMarketSegment = [...new Set(bookingMarketSegment.concat($refs['bookingMarketSegment'].filteredItems.map(e => e.code)))]">{{ $t('SELECT_ALL') }}</a> | <a
                        class="text-primary" @click="bookingMarketSegment = []">{{ $t('UN_SELECT_ALL') }}</a>
                    </p>
                  </template>

                  <template v-slot:selection="{ item, index }">
                    <v-chip color="primary" v-if="index === 0" v-bind="item.attrs" :input-value="item.selected" close
                      @click:close="remove(index, bookingMarketSegment)" @click="item.select">
                      <span>{{ item.name }}</span>
                    </v-chip>
                    <span v-if="index === 1" class="grey--text caption">(+{{ bookingMarketSegment.length - 1 }})</span>
                  </template>
                  <template slot="no-data">
                    <div class="no-data">{{ $t("NO_DATA") }}</div>
                  </template>
                </v-autocomplete>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6" class="pt-0 pr-0">
                <label>
                  {{ $t("ROOM_TYPE") }}
                </label>
                <v-autocomplete chips dense multiple outlined item-text="text" item-value="value" :items="listSearchRoomTypes"
                  v-model="selectedSearchRoomType" ref="selectedSearchRoomType">
                  <template v-slot:prepend-item>
                    <p class="mx-3 mt-1"> <a class="text-primary"
                        @click="selectedSearchRoomType = [...new Set(selectedSearchRoomType.concat($refs['selectedSearchRoomType'].filteredItems.map(e => e.value)))]">{{ $t('SELECT_ALL') }}</a> | <a
                        class="text-primary" @click="selectedSearchRoomType = []">{{ $t('UN_SELECT_ALL') }}</a>
                    </p>
                  </template>

                  <template v-slot:selection="{ item, index }">
                    <v-chip color="primary" v-if="index === 0" v-bind="item.attrs" :input-value="item.selected" close
                      @click:close="remove(index, selectedSearchRoomType)" @click="item.select">
                      <span>{{ item.text }}</span>
                    </v-chip>
                    <span v-if="index === 1" class="grey--text caption">(+{{ selectedSearchRoomType.length - 1 }})</span>
                  </template>
                  <template slot="no-data">
                    <div class="no-data">{{ $t("NO_DATA") }}</div>
                  </template>
                </v-autocomplete>
              </b-col>
              <b-col md="6" class="pt-0">
                <label>
                  {{ $t("HOTEL_RATE_PLAN") }}
                </label>
                <v-autocomplete chips dense multiple outlined item-text="text" item-value="value" :items="listSearchRatePlans"
                  v-model="selectedSearchRatePlan" ref="selectedSearchRatePlan">
                  <template v-slot:prepend-item>
                    <p class="mx-3 mt-1"> <a class="text-primary"
                        @click="selectedSearchRatePlan = [...new Set(selectedSearchRatePlan.concat($refs['selectedSearchRatePlan'].filteredItems.map(e => e.value)))]">{{ $t('SELECT_ALL') }}</a> | <a
                        class="text-primary" @click="selectedSearchRatePlan = []">{{ $t('UN_SELECT_ALL') }}</a>
                    </p>
                  </template>

                  <template v-slot:selection="{ item, index }">
                    <v-chip color="primary" v-if="index === 0" v-bind="item.attrs" :input-value="item.selected" close
                      @click:close="remove(index, selectedSearchRatePlan)" @click="item.select">
                      <span>{{ item.text }}</span>
                    </v-chip>
                    <span v-if="index === 1" class="grey--text caption">(+{{ selectedSearchRatePlan.length - 1 }})</span>
                  </template>
                  <template slot="no-data">
                    <div class="no-data">{{ $t("NO_DATA") }}</div>
                  </template>
                </v-autocomplete>
              </b-col>
            </b-row>
          </div>
            <!-- End coding -->
            <div class="d-flex justify-end align-items-end flex-wrap py-0 mb-2">
                <div class="mr-3 reset">
                    <v-btn class="pl-5 pr-5" @click="reset()">
                        <v-icon size="20" left>
                            mdi-refresh
                        </v-icon>
                        {{ $t("_BOOKING.RESET") }}
                    </v-btn>
                </div>
                <div class="mr-3">
                    <v-btn color="primary" class="pl-5 pr-5" @click="getAll(true)">
                        <v-icon size="20" left>
                            search
                        </v-icon>
                        {{ $t("_BOOKING.SEARCH") }}
                    </v-btn>
                </div>
            </div>
        </div>
        <!-- end -->
      </div>
      <!-- button scroll -->
      <div ref="containerCondition" class="container-condition py-4 pt-0">
        <div class="d-flex align-items-center">
          <button
            v-if="isShowArrow"
            class="left round"
            @click="scrollLeft"
          >
          <v-icon>mdi-chevron-left</v-icon>
          </button>
          
          <div ref="scrollContainer" class="overflow-auto scroll-container">
            <div v-if="conditionSearch === 'BOOKING_DATE'" class="d-inline-flex gap-3">
              <label class="" :title="conditionSearch === 'BOOKING_DATE' && conditionDateRange[0] ? formatDate(conditionSearch, conditionDateRange) : ''">
                <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionSearch === 'BOOKING_DATE' && conditionDateRange[0] && !isClear ? 'active-condition' : ''">
                  {{ this.$t("_BOOKING.SEARCH_BY.BOOKING_DATE") }} {{ conditionSearch === 'BOOKING_DATE' && conditionDateRange[0] && !isClear ? ': '+ formatDate(conditionSearch, conditionDateRange) : ''  }}
                </div>
              </label>
            </div>

            <div v-if="conditionSearch === 'CHECKIN_DATE'" class="d-inline-flex gap-3">
              <label class="" :title="conditionSearch === 'CHECKIN_DATE' && conditionDateRange[0] ? formatDate(conditionSearch, conditionDateRange) : ''">
                <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionSearch === 'CHECKIN_DATE' && conditionDateRange[0] && !isClear ? 'active-condition' : ''">
                  {{ this.$t("_BOOKING.SEARCH_BY.CHECKIN_DATE") }} {{ conditionSearch === 'CHECKIN_DATE' && conditionDateRange[0] && !isClear ? ': '+ formatDate(conditionSearch, conditionDateRange) : ''  }}
                </div>
              </label>
            </div>

            <div v-if="conditionSearch === 'CHECKOUT_DATE'" class="d-inline-flex gap-3">
              <label class="" :title="conditionSearch === 'CHECKOUT_DATE' && conditionDateRange[0] ? formatDate(conditionSearch, conditionDateRange) : ''">
                <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionSearch === 'CHECKOUT_DATE' && conditionDateRange[0] && !isClear ? 'active-condition' : ''">
                  {{ this.$t("_BOOKING.SEARCH_BY.CHECKOUT_DATE") }} {{ conditionSearch === 'CHECKOUT_DATE' && conditionDateRange[0] && !isClear ? ': '+ formatDate(conditionSearch, conditionDateRange) : ''  }}
                </div>
              </label>
            </div>

            <div v-if="conditionSearch === 'STAY_DATE'" class="d-inline-flex gap-3">
              <label class="" :title="conditionStayDate ? formatDate(conditionSearch, conditionStayDate) : ''">
                <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionSearch === 'STAY_DATE' && conditionStayDate && !isClear ? 'active-condition' : ''">
                  {{ this.$t("_BOOKING.SEARCH_BY.STAYING_DATE") }} {{ conditionSearch === 'STAY_DATE' && conditionStayDate && !isClear ? ': '+ formatDate(conditionSearch, conditionStayDate) : ''  }}
                </div>
              </label>
            </div>

            <div v-if="listNameOTA && listNameOTA.length > 0" class="d-inline-flex gap-3">
              <label :title="listNameOTA.join('\n')">
                <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="listNameOTA.length > 0 && !isClear ? 'active-condition' : ''">
                  {{ $t("BOOKING_CHANNEL") }} {{ listNameOTA.length > 0 && !isClear ? (listNameOTA.length > 1 ? ': ' + listNameOTA[0]+'...' : ': ' + listNameOTA[0]) : ''  }}
                </div>		
              </label>
            </div>

            <div v-if="listNameHotel && listNameHotel.length > 0" class="d-inline-flex gap-3">
              <label :title="listNameHotel.join('\n')">
                <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="listNameHotel.length > 0 && !isClear ? 'active-condition' : ''">
                  {{ $t("BOOKING_HOTEL") }} {{ listNameHotel.length > 0 && !isClear ? (listNameHotel.length > 1 ? ': ' + listNameHotel[0]+'...' : ': ' + listNameHotel[0]) : ''  }}
                </div>		
              </label>
            </div>

            <div v-if="listNameBKStatus && listNameBKStatus.length > 0" class="d-inline-flex gap-3">
              <label :title="listNameBKStatus.join('\n')">
                <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="listNameBKStatus.length > 0 && !isClear ? 'active-condition' : ''">
                  {{ $t("_BOOKING_TRANSACTION.BOOKING_STATUS") }} {{ listNameBKStatus.length > 0 && !isClear ? (listNameBKStatus.length > 1 ? ': ' + listNameBKStatus[0]+'...' : ': ' + listNameBKStatus[0]) : ''  }}
                </div>		
              </label>
            </div>

            <div v-if="listNamePmsStt && listNamePmsStt.text" class="d-inline-flex gap-3">
              <label :title="listNamePmsStt && listNamePmsStt.text">
                <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="listNamePmsStt && !isClear ? 'active-condition' : ''">
                  {{ $t("_BOOKING.SEARCH_PMS_STATUS") }} {{ listNamePmsStt && !isClear ? ': ' + listNamePmsStt.text : '' }}
                </div>		
              </label>
            </div>

            <div v-if="listNamePmsCode && listNamePmsCode.length > 0" class="d-inline-flex gap-3">
                <label :title="listNamePmsCode.join('\n')">
                <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="listNamePmsCode.length > 0 && !isClear ? 'active-condition' : ''">
                    {{ $t("_BOOKING.SEARCH_PMS_CODE") }} {{ listNamePmsCode.length > 0 && !isClear ? (listNamePmsCode.length > 1 ? ': ' + listNamePmsCode[0]+'...' : ': ' + listNamePmsCode[0]) : ''  }}
                </div>
                </label>
            </div>

            <div v-if="conditionCustomerName" class="d-inline-flex gap-3">
              <label :title="conditionCustomerName">
                <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionCustomerName && !isClear ? 'active-condition' : ''">
                  {{  $t("SEARCH_BY_BOOKER") }} {{ conditionCustomerName && !isClear ? ': ' + conditionCustomerName : '' }}
                </div>		
              </label>
            </div>
            
            <div v-if="conditionCustomerPhone" class="d-inline-flex gap-3">
              <label :title="conditionCustomerPhone">
                <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionCustomerPhone && !isClear ? 'active-condition' : ''">
                  {{  $t("CUSTOMER_PHONE") }} {{ conditionCustomerPhone && !isClear ? ': ' + conditionCustomerPhone : '' }}
                </div>		
              </label>
            </div>

            <div v-if="conditionCustomerStay" class="d-inline-flex gap-3">
              <label :title="conditionCustomerStay">
                <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionCustomerStay && !isClear ? 'active-condition' : ''">
                  {{  $t("NAME_OF_GUEST_STAYING") }} {{ conditionCustomerStay && !isClear ? ': ' + conditionCustomerStay : '' }}
                </div>		
              </label>
            </div>

            <div v-if="conditionCreatedByName" class="d-inline-flex gap-3">
              <label :title="conditionCreatedByName">
                <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionCreatedByName && !isClear ? 'active-condition' : ''">
                  {{  $t("CREATED_BY_ACCOUNT") }} {{ conditionCreatedByName && !isClear ? ': ' + conditionCreatedByName : '' }}
                </div>		
              </label>
            </div>

            <div v-if="conditionUtmCode" class="d-inline-flex gap-3">
              <label :title="conditionUtmCode">
                <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionUtmCode && !isClear ? 'active-condition' : ''">
                  {{ $t("UTM_CODE") }} {{ conditionUtmCode && !isClear ? ': ' + conditionUtmCode : '' }}
                </div>		
              </label>
            </div> 

            <div v-if="conditionBookingTravelAgent && conditionBookingTravelAgent.length > 0" class="d-inline-flex gap-3">
              <label :title="conditionBookingTravelAgent.join('\n')">
                <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionBookingTravelAgent.length > 0 && !isClear ? 'active-condition' : ''">
                  {{ $t("_BOOKING.AGENT") }} {{ conditionBookingTravelAgent.length > 0 && !isClear ? (conditionBookingTravelAgent.length > 1 ? ': ' + conditionBookingTravelAgent[0]+'...' : ': ' + conditionBookingTravelAgent[0]) : ''  }}
                </div>		
              </label>
            </div>

            <div v-if="conditionBookingSegments && conditionBookingSegments.length > 0" class="d-inline-flex gap-3">
              <label :title="conditionBookingSegments.join('\n')">
                <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionBookingSegments.length > 0 && !isClear ? 'active-condition' : ''">
                  {{ $t("_BOOKING.MARKET") }} {{ conditionBookingSegments.length > 0 && !isClear ? (conditionBookingSegments.length > 1 ? ': ' + conditionBookingSegments[0]+'...' : ': ' + conditionBookingSegments[0]) : ''  }}
                </div>		
              </label>
            </div>

            <div v-if="listNameRoomType && listNameRoomType.length > 0" class="d-inline-flex gap-3">
              <label :title="listNameRoomType.join('\n')">
                <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="listNameRoomType.length > 0 && !isClear ? 'active-condition' : ''">
                  {{ $t("ROOM_TYPE") }} {{ listNameRoomType.length > 0 && !isClear ? (listNameRoomType.length > 1 ? ': ' + listNameRoomType[0]+'...' : ': ' + listNameRoomType[0]) : ''  }}
                </div>		
              </label>
            </div>

            <div v-if="listNameRatePlane && listNameRatePlane.length > 0" class="d-inline-flex gap-3">
              <label :title="listNameRatePlane.join('\n')">
                <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="listNameRatePlane.length > 0 && !isClear ? 'active-condition' : ''">
                  {{ $t("HOTEL_RATE_PLAN") }} {{ listNameRatePlane.length > 0 && !isClear ? (listNameRatePlane.length > 1 ? ': ' + listNameRatePlane[0]+'...' : ': ' + listNameRatePlane[0]) : ''  }}
                </div>		
              </label>
            </div>

          </div>
          <button
            v-if="isShowArrow"
            class="right round"
            @click="scrollRight"
          >
            <v-icon>mdi-chevron-right</v-icon>
          </button>
        </div>
      </div>
      <!-- button scroll -->
      <hr class="mt-0">
      <v-progress-linear class="custom-progress" color="warning" indeterminate rounded height="3" v-if="isLoading"></v-progress-linear>
      <v-list>
        <v-list-item>
          <div class="d-flex w-100">
            <div class="mr-auto font-weight-bold fs-14">
              {{ $t('TOTAL') }}
            </div>
            <div class="ml-3 total-group-ota"><span class="font-weight-bold fs-14">{{ $tc('ADULT_CAP', totals.totalAdults)
            }}
              </span></div>
            <div class="ml-3 total-group-ota"><span class="font-weight-bold fs-14">{{ $tc('CHILD_CAP', totals.totalChilds)
            }}
              </span></div>
            <div class="ml-3 total-group-ota"><span class="font-weight-bold fs-14">{{ $tc('BABY_CAP', totals.totalBabys)
            }}
              </span></div>
            <div class="ml-3 total-group-ota"><span class="font-weight-bold fs-14">{{ $tc('ROOM_CAP', totals.rooms) }}
              </span></div>
            <div class="ml-3 total-group-ota"><span class="font-weight-bold fs-14">{{ $tc('NIGHT_CAP', totals.nights) }}
              </span></div>
            <div class="ml-3 total-group-ota"><span class="font-weight-bold fs-14">{{ $tc('BOOKING_CAP', totals.bookings)
            }} </span></div>
          </div>
        </v-list-item>
        <v-list-group v-for="hotel in hotelsData " :key="hotel.hotelName" class="gr-hotel" sub-group :value="true">
          <template v-slot:activator>
            <div class="d-flex w-100">
              <div class="mr-auto font-weight-bold">
                {{ hotel.hotelName }}
              </div>
              <div class="ml-3 total-group-ota"><span class="font-weight-bold">{{
                $tc('ADULT_CAP', totalNumber(hotel.groupByOTA.map(e => +e.totalAdults))) }} </span></div>
              <div class="ml-3 total-group-ota"><span class="font-weight-bold">{{
                $tc('CHILD_CAP', totalNumber(hotel.groupByOTA.map(e => +e.totalChilds))) }} </span></div>
              <div class="ml-3 total-group-ota"><span class="font-weight-bold">{{
                $tc('BABY_CAP', totalNumber(hotel.groupByOTA.map(e => +e.totalBabys))) }} </span></div>
              <div class="ml-3 total-group-ota"><span class="font-weight-bold">{{
                $tc('ROOM_CAP', totalNumber(hotel.groupByOTA.map(e => +e.totalRooms))) }} </span></div>
              <div class="ml-3 total-group-ota"><span class="font-weight-bold">{{ $tc('NIGHT_CAP',
                totalNumber(hotel.groupByOTA.map(e => +e.totalNights))) }} </span></div>
              <div class="ml-3 total-group-ota"><span class="font-weight-bold">{{
                $tc('BOOKING_CAP', totalNumber(hotel.groupByOTA.map(e => +e.totalBookings))) }} </span></div>
            </div>
          </template>

          <v-list-group color="primary" class="gr-ota" @click="showBookingOta(hotel, ota); $forceUpdate();"
            v-model="ota.active" no-action sub-group v-for="ota in    hotel.groupByOTA   "
            :key="ota.otaId + hotel.hotelId">
            <template v-slot:activator>
              <div class="d-flex w-100">
                <div class="mr-auto">
                  {{ ota.otaName }}
                  <v-progress-circular v-if="ota.isLoading" :size="20" indeterminate
                    color="primary"></v-progress-circular>
                </div>
                <div class="ml-3 total-group-ota"><span class="font-weight-bold">{{ $tc('ADULT_CAP', ota.totalAdults) }}
                  </span></div>
                <div class="ml-3 total-group-ota"><span class="font-weight-bold">{{ $tc('CHILD_CAP', ota.totalChilds) }}
                  </span></div>
                <div class="ml-3 total-group-ota"><span class="font-weight-bold">{{ $tc('BABY_CAP', ota.totalBabys) }}
                  </span></div>
                <div class="ml-3 total-group-ota"><span class="font-weight-bold">{{ $tc('ROOM_CAP', ota.totalRooms) }}
                  </span></div>
                <div class="ml-3 total-group-ota"><span class="font-weight-bold">{{ $tc('NIGHT_CAP', ota.totalNights) }}
                  </span></div>
                <div class="ml-3 total-group-ota"><span class="font-weight-bold">{{ $tc('BOOKING_CAP', ota.totalBookings)
                }} </span></div>
              </div>
            </template>
            <template>
              <div>
                <v-simple-table class="table-booking">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th v-for="header in headers" :key="header.value"
                          :class="columViews.includes(header.value) || header.default ? header.class : 'd-none'">
                          {{ header.text }}
                          <template v-if="['priceBeforeCommission', 'priceAfterCommission'].includes(header.value)">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on" class="fs-14">mdi-information</v-icon>
                              </template>
                              <div class="fs-13" style="max-width: 300px">{{ $t('COMMISSION_RATE_NOTE') }}</div>
                            </v-tooltip>
                          </template>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      
                      <template v-if="ota.bookingData.length > 0">
                        <template v-for="(item, i) in ota.bookingData">
                          <tr v-for="(line, ii) in item.bookingLines.filter(e => e.bookingLineType === 0)" :key="ii + item.bookingCode">
                            <td class="text-center vertical-middle" v-if="ii === 0"
                              :rowspan="item.bookingLines.filter(e => e.bookingLineType === 0).length">{{
                                ota.paging.offset
                                + i + 1 }}</td>
                            <td class="vertical-middle font-weight-bold  txt-nowrap" v-if="ii === 0"
                              :rowspan="item.bookingLines.filter(e => e.bookingLineType === 0).length">
                              <a class="app-link text-decoration-none" href="javascript:;"
                                @click.stop="goToBookingDetail(item.bookingCode)">
                                {{
                                  item.bookingCustomer.name + ' ' + item.bookingCustomer.surname
                                }}
                              </a>
                            </td>
                            <td class="vertical-middle text-center" v-if="ii === 0"
                              :rowspan="item.bookingLines.filter(e => e.bookingLineType === 0).length">{{
                                item.otaBookingCode }}</td>
                            <td class="text-center vertical-middle" v-if="ii === 0"
                              :rowspan="item.bookingLines.filter(e => e.bookingLineType === 0).length">
                              {{
                                item.bookingCode
                              }}
                            </td>
                            <td class="text-right vertical-middle" v-if="ii === 0"
                              :rowspan="item.bookingLines.filter(e => e.bookingLineType === 0).length">
                              <template v-if="systemLang == 'vi'">
                                {{
                                  _formatDateTime(item.arrival, "YYYY-MM-DD", "DD/MM/YYYY")
                                }} <br>
                                {{ _formatDateTime(item.departure, "YYYY-MM-DD", "DD/MM/YYYY") }}
                              </template>
                              <template v-else>
                                {{
                                  _formatDateTime(item.arrival, "YYYY-MM-DD", "YYYY/MM/DD")
                                }} <br>
                                {{ _formatDateTime(item.departure, "YYYY-MM-DD", "YYYY/MM/DD") }}
                              </template>
                            </td>
                            <td class="vertical-middle pl-0 py-1" v-if="columViews.includes('bookingLines_room')">

                              {{ line.roomType.roomTypeI18n.find(x => x.lang == defaultI18n).name }}
                            </td>
                            <td class="vertical-middle pl-0 py-1" v-if="columViews.includes('bookingLines_ratePlan')">

                              {{
                                line.ratePlan.i18ns.find(x => x.lang == defaultI18n).name }}
                            </td>
                            <td class="vertical-middle text-right pl-0 py-1"
                              v-if="columViews.includes('bookingLines_price')">

                              <span class="font-weight-bold">{{
                                formatCurrency(line.amountPax / line.nights
                                  , item.currencyCode) }}</span>
                            </td>

                            <td class="vertical-middle  text-right  py-1" v-if="columViews.includes('adult')">

                              {{ line.adults }}
                            </td>
                            <td class="vertical-middle text-right  py-1" v-if="columViews.includes('child')">

                              {{ line.children }}
                            </td>
                            <td class="vertical-middle text-right  py-1" v-if="columViews.includes('baby')">

                              {{ line.baby }}
                            </td>
                            <td class="text-right vertical-middle font-weight-bold" v-if="ii === 0"
                              :rowspan="item.bookingLines.filter(e => e.bookingLineType === 0).length">
                              {{ formatCurrency(item.amount, item.currencyCode) }}
                            </td>
                            <td class="vertical-middle" v-if="columViews.includes('agent') && ii === 0"
                              :rowspan="item.bookingLines.filter(e => e.bookingLineType === 0).length">
                              {{ item.bookingTravelAgents.length > 0 ? item.bookingTravelAgents[0].nameVi : '' }}
                            </td>
                            <td class="vertical-middle" v-if="columViews.includes('market') && ii === 0"
                              :rowspan="item.bookingLines.filter(e => e.bookingLineType === 0).length">
                              {{ item.bookingMarketSegments.length > 0 ? item.bookingMarketSegments[0].nameVi : '' }}
                            </td>
                            <td class="text-center vertical-middle" v-if="ii === 0"
                              :rowspan="item.bookingLines.filter(e => e.bookingLineType === 0).length"
                              :style="{ color: listBookingStatus.find(x => x.value == item.bookingStatus).color }">
                              {{
                                listBookingStatus.find(x => x.value == item.bookingStatus).text
                              }}
                            </td>
                            <td class="text-center vertical-middle"
                              v-if="columViews.includes('checkinStatus') && ii === 0"
                              :rowspan="item.bookingLines.filter(e => e.bookingLineType === 0).length">
                              {{
                                item.checkinStatus !== null ? listCheckinStatus.find(x => +x.value == +item.checkinStatus
                                ).text : item.checkinStatus
                              }}
                            </td>
                            <td class="text-right vertical-middle" v-if="columViews.includes('numRoom') && ii === 0"
                              :rowspan="item.bookingLines.filter(e => e.bookingLineType === 0).length">
                              {{ item.rooms }}
                            </td>
                            <td class="text-right vertical-middle" v-if="columViews.includes('numNight') && ii === 0"
                              :rowspan="item.bookingLines.filter(e => e.bookingLineType === 0).length">
                              {{ item.nights }}
                            </td>
                            <td class="vertical-middle" v-if="columViews.includes('createdByName') && ii === 0"
                              :rowspan="item.bookingLines.filter(e => e.bookingLineType === 0).length">
                              {{ item.createdByName }}
                            </td>
                            <td class="text-center vertical-middle" :title="findTimeZone(item.timeZoneStr)"
                              :rowspan="item.bookingLines.filter(e => e.bookingLineType === 0).length"
                              v-if="columViews.includes('bookingDate') && ii === 0">
                              {{ formatDateTime(item.createdDate) }}
                            </td>
                            <td class="vertical-middle cursor" :title="item.comment"
                              v-if="columViews.includes('comment') && ii === 0"
                              :rowspan="item.bookingLines.filter(e => e.bookingLineType === 0).length">
                              <p class="mb-0 text-truncate" style="max-width: 50px">{{ item.comment }}</p>
                            </td>
                            <td class="vertical-middle cursor" :title="item.utmSource"
                              v-if="columViews.includes('utmSource') && ii === 0"
                              :rowspan="item.bookingLines.filter(e => e.bookingLineType === 0).length">
                              <p class="mb-0 text-truncate" style="max-width: 50px">{{ item.utmSource }}</p>
                            </td>
                            <td class="vertical-middle cursor" :title="item.utmMedium"
                              v-if="columViews.includes('utmMedium') && ii === 0"
                              :rowspan="item.bookingLines.filter(e => e.bookingLineType === 0).length">
                              <p class="mb-0 text-truncate" style="max-width: 50px">{{ item.utmMedium }}</p>
                            </td>
                            <td class="vertical-middle cursor" :title="item.utmCampaign"
                              v-if="columViews.includes('utmCampaign') && ii === 0"
                              :rowspan="item.bookingLines.filter(e => e.bookingLineType === 0).length">
                              <p class="mb-0 text-truncate" style="max-width: 50px">{{ item.utmCampaign }}</p>
                            </td>
                            <td class="vertical-middle cursor" :title="item.utmTerm"
                              v-if="columViews.includes('utmTerm') && ii === 0"
                              :rowspan="item.bookingLines.filter(e => e.bookingLineType === 0).length">
                              <p class="mb-0 text-truncate" style="max-width: 50px">{{ item.utmTerm }}</p>
                            </td>
                            <td class="vertical-middle cursor" :title="item.utmContent"
                              v-if="columViews.includes('utmContent') && ii === 0"
                              :rowspan="item.bookingLines.filter(e => e.bookingLineType === 0).length">
                              <p class="mb-0 text-truncate" style="max-width: 50px">{{ item.utmContent }}</p>
                            </td>
                            <td class="vertical-middle cursor text-center" :title="item.paymentCollectType"
                              v-if="columViews.includes('paymentCollectType') && ii === 0"
                              :rowspan="item.bookingLines.filter(e => e.bookingLineType === 0).length">
                             {{ item.paymentCollectType === 0 ? 'Property collect' : item.paymentCollectType === 1 ? 'OTA contact' : 'Channel collect' }}
                            </td>
                            <td v-if="columViews.includes('priceBeforeCommission') && ii === 0" class="text-right vertical-middle font-weight-bold"
                            :rowspan="item.bookingLines.filter(e => e.bookingLineType === 0).length">
                              <strong>{{item.priceBeforeCommission ? formatCurrency(item.priceBeforeCommission, item.currencyCode) : 'N/A' }}</strong>
                            </td>
                            <td v-if="columViews.includes('commission') && ii === 0" class="text-right vertical-middle font-weight-bold"
                            :rowspan="item.bookingLines.filter(e => e.bookingLineType === 0).length">
                              <strong>{{ item.commission ? formatCurrency(item.commission, item.currencyCode) : 'N/A' }}</strong>
                            </td>
                            <td v-if="columViews.includes('priceAfterCommission') && ii === 0" class="text-right vertical-middle font-weight-bold"
                            :rowspan="item.bookingLines.filter(e => e.bookingLineType === 0).length">
                              <strong>{{item.priceAfterCommission ? formatCurrency(item.priceAfterCommission, item.currencyCode) : 'N/A'}}</strong>
                            </td>
                           
                           
                            <td class="text-center vertical-middle" v-if="ii === 0"
                              :rowspan="item.bookingLines.filter(e => e.bookingLineType === 0).length">
                              <template v-if="item.pmsCode">
                                <v-menu bottom left>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn depressed :color="item.channelStatus === 1 ? 'success' : ''" x-small
                                      v-bind="attrs" v-on="on" class="rounded-sm  mr-1" outlined>
                                      <i class="icon-more_vert fs-18 cursor font-weight-bold"></i>
                                    </v-btn>
                                  </template>

                                <div class="d-flex bg-white p-2">
                                  <div class="mr-3">
                                    <p v-if="item.channelStatus === 1" class="m-0 pr-3">
                                      <span class="text-success">{{ $t('_DASHBOARD._HOTEL_STATUS_SYNC_PMS.RECEIVED')
                                      }}</span>
                                      <br>
                                      <span class="fs-12">{{
                                        formatDateTime(item.channelTime)
                                      }}</span>
                                    </p>
                                    <p v-else class="m-0 pr-3">{{ $t('_DASHBOARD._HOTEL_STATUS_SYNC_PMS.NOT_RECEIVED') }}
                                    </p>
                                  </div>
                                  <div class="text-right">
                                    <p class="mb-0">{{ item.pmsCode.split(',').map(e => $t(e)).join(", ") }}</p>
                                    <v-btn color="success" v-if="fnReSync" x-small @click.stop="openPopupReSync(item)"><small>{{
                                      $t('RE_SYNC') }}</small></v-btn>
                                  </div>
                                  </div>
                                </v-menu>
                              </template>
                            </td>
                          </tr>
                        </template>

                      </template>
                      <template v-else>
                        <tr>
                          <td colspan="14" class="text-center vertical-middle font-weight-bold font-italic"
                            style="color:red">
                            {{ $t('BOOKING_EMPTY') }}
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </template>
                </v-simple-table>
                <v-row
                  class="mt-2 mx-3"
                  align="center"
                  justify="center"
                >
                  <span class="grey--text">{{  $t('ITEMS_PER_PAGE') }}</span>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        dark
                        text
                        color="primary"
                        class="ml-2"
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ ota.paging.limit }}
                        <v-icon>mdi-chevron-down</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(number, index) in itemsPerPageArray"
                        :key="index"
                        @click="ota.paging.limit = number; ota.paging.offset = 0 ; changePage(hotel, ota)"
                      >
                        <v-list-item-title>{{ number }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>

                  <v-spacer></v-spacer>

                  <paging :paging.sync="ota.paging" @changePage=" changePage(hotel, ota)" class="pr-3" v-if="ota.isLoading === false">
                    <span slot="totalItems">{{ $t("TOTAL") }}: {{ $tc("_BOOKING.BOOKING", ota.paging.total) }}</span>
                  </paging>
                </v-row>
                
              </div>
            </template>
          </v-list-group>
        </v-list-group>
      </v-list>
    </div>
    <confirm-dialog @deleteItem="reSync" :maxWidth="325" :persistent="true" ref="reSyncDialogComponent">
      <span slot="title">{{ $t("CONFIRM_RE_SYNC") }} booking: {{ bookingReSync ? bookingReSync.otaBookingCode :
        null }}</span>
    </confirm-dialog>
    <v-navigation-drawer
      v-model="showDetail"
      absolute
      temporary
      right
      width="1000"
    >
      <booking-detail-group 
        v-if="showDetail" 
        :code="code" 
        @close="()=> {showDetail = false}"
      ></booking-detail-group>
    </v-navigation-drawer>
  </div>
</template>
   
<script>
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import Paging from "@/components/Utils/Paging.vue";
import { syncota } from "@/_services/SyncOTA/syncota.js";
import { chainService } from "@/_services/ChainManage/chain.service.js";
import {
  _alert,
  _formatCurrency,
  _formatDateTimeUTCToLocal
} from "@/_helpers/function.js";
import moment from "moment";
import FileSaver from "file-saver";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import ConfirmDialog from "@/components/Utils/ConfirmDialog.vue";
import BookingDetailGroup from './BookingDetailGroup.vue';

export default {
  components: {
    DateRangePicker,
    paging: Paging,
    "date-picker": DatePicker,
    "confirm-dialog": ConfirmDialog,
    BookingDetailGroup
  },
  data() {
    return {
      menu: false,
      textSearch: '',
      locale_data: {
        format: 'YYYY-MM-DD',
        separator: ' - ',
        applyLabel: 'Apply',
        cancelLabel: 'Cancel',
        weekLabel: 'W',
        daysOfWeek: [this.$t("_DATE_RANGE.SUNDAY"), this.$t("_DATE_RANGE.MONDAY"), this.$t("_DATE_RANGE.TUESDAY"), this.$t("_DATE_RANGE.WEDNESDAY"), this.$t("_DATE_RANGE.THURSDAY"), this.$t("_DATE_RANGE.FRIDAY"), this.$t("_DATE_RANGE.SATURDAY")],
        monthNames: [this.$t("_DATE_RANGE.JAN"), this.$t("_DATE_RANGE.FEB"), this.$t("_DATE_RANGE.MAR"), this.$t("_DATE_RANGE.APR"), this.$t("_DATE_RANGE.MAY"), this.$t("_DATE_RANGE.JUN"), this.$t("_DATE_RANGE.JUL"), this.$t("_DATE_RANGE.AUG"), this.$t("_DATE_RANGE.SEP"), this.$t("_DATE_RANGE.OTC"), this.$t("_DATE_RANGE.NOV"), this.$t("_DATE_RANGE.DEC")],
        firstDay: 1
      },
      dateRange: [],
      stayDate: null,
      systemLang: this.$i18n.locale,
      isLoading: false,
      headers: [
        {
          text: this.$t("STT"),
          class: "text-center",
          value: 'stt',
          default: true,
        },
        {
          text: this.$t("BOOKING_CUSTOMER_NAME"),
          value: "name",
          default: true,
        },
        {
          text: this.$t("BOOKING_CODE_OTA"),
          value: "otaBookingCode",
          class: "text-center",
          default: true,
        },
        {
          text: this.$t("_BOOKING.BOOKING_CODE"),
          class: "text-center",
          value: "bookingCode",
          default: true,
        },
        {
          text: this.$t("_BOOKING.TIME_STAY"),
          value: "timeStay",
          class: "text-right",
          default: true,
        },
        {
          text: this.$t("ROOM_TYPE"),
          value: "bookingLines_room",
          default: false,
        },
        {
          text: this.$t("SALE_PACKAGE"),
          value: "bookingLines_ratePlan",
          default: false,
        },
        {
          text: this.$t("PRICE"),
          value: "bookingLines_price",
          default: false,
          class: "text-right",
        },
        {
          text: this.$t("ADULT"),
          value: "adult",
          default: false,
          class: "text-right",
        },
        {
          text: this.$t("CHILDREN"),
          value: "child",
          default: false,
          class: "text-right",
        },
        {
          text: this.$t("_BOOKING_DETAIL.ROOM.BABY"),
          value: "baby",
          default: false,
          class: "text-right",
        },
        {
          text: this.$t("_BOOKING.AMOUNT"),
          value: "totalAmount",
          class: "text-right",
          default: true,
        },
        {
          text: this.$t("_BOOKING.AGENT"),
          value: "agent",
          class: "",
          default: false,
        },
        {
          text: this.$t("_BOOKING.MARKET"),
          value: "market",
          class: "",
          default: false,
        },
        {
          text: this.$t("_BOOKING_TRANSACTION.BOOKING_STATUS"),
          class: "text-center",
          value: "bookingStatus",
          default: true,
        },
        {
          text: this.$t("_BOOKING.CHECKIN_STATUS"),
          class: "text-center",
          value: "checkinStatus",
          default: false,
        },
        {
          text: this.$t("NUMBER_ROOM"),
          class: "text-right",
          value: "numRoom",
          default: false,
        },
        {
          text: this.$t("NUMBER_NIGHT"),
          class: "text-right",
          value: "numNight",
          default: false,
        },
        {
          text: this.$t("CREATED_BY_ACCOUNT"),
          value: "createdByName",
          default: false,
        },
        {
          text: this.$t("_BOOKING.BOOKING_DATE"),
          value: "bookingDate",
          class: "text-center",
          default: false,
        },
        {
          text: this.$t("_BOOKING_DETAIL.BOOKING_DETAIL.NOTE"),
          value: "comment",
          default: false,
        },
        {
          text: "UTM Source",
          value: "utmSource",
          default: false,
        },
        {
          text: "UTM Medium",
          value: "utmMedium",
          default: false,
        },
        {
          text: "UTM Campaign",
          value: "utmCampaign",
          default: false,
        },
        {
          text: "UTM Term",
          value: "utmTerm",
          default: false,
        },
        {
          text: "UTM Content",
          value: "utmContent",
          default: false,
        },
        {
          text: 'Payment collect',
          value: "paymentCollectType",
          class: "text-center",
          default: false
        },
        {
          text: this.$t('_BOOKING_DETAIL.BEFORE_COMMISSION'),
          value: "priceBeforeCommission",
          class: "text-right",
        },
        {
          text: this.$t('_BOOKING_DETAIL.COMMISSION'),
          value: "commission",
          class: "text-right",
        },
        {
          text: this.$t('_BOOKING_DETAIL.AFTER_COMMISSION'),
          value: "priceAfterCommission",
          class: "text-right",
        },
        {
          text: this.$t("_DASHBOARD.SYNC_PMS"),
          value: "syncPms",
          class: "text-center",
          default: true,
        },
      ],
      dataTable: [],
      selectedSearchCondition: 'BOOKING_DATE',
      listSearchCondition: [
        {
          value: "BOOKING_CODE",
          text: this.$t("_BOOKING.SEARCH_BY.BOOKING_CODE")
        },
        {
          value: "BOOKING_CODE_OTA",
          text: this.$t("BOOKING_CODE_OTA")
        },
        {
          value: "BOOKING_DATE",
          text: this.$t("_BOOKING.SEARCH_BY.BOOKING_DATE")
        },
        {
          value: "CHECKIN_DATE",
          text: this.$t("_BOOKING.SEARCH_BY.CHECKIN_DATE")
        },
        {
          value: "CHECKOUT_DATE",
          text: this.$t("_BOOKING.SEARCH_BY.CHECKOUT_DATE")
        },
        {
          value: "STAY_DATE",
          text: this.$t("_BOOKING.SEARCH_BY.STAYING_DATE")
        }
      ],
      selectedBookingStatus: [],
      listBookingStatus: [
        {
          value: 0,
          text: this.$t("_BOOKING.STATUS.AWAIT_PAYMENT"),
          color: "rgb(254, 209, 47)"
        },
        {
          value: 1,
          text: this.$t("_BOOKING.STATUS.CONFIRM"),
          color: "#0da313"
        },
        {
          value: 2,
          text: this.$t("_BOOKING.STATUS.CANCEL"),
          color: "#808080"
        },
        {
          value: 3,
          text: this.$t("_BOOKING.STATUS.VOID"),
          color: "#262626"
        },
        {
          value: 4,
          text: this.$t("_BOOKING.STATUS.IN_SERVICE"),
          color: "#262626"
        },
        {
          value: 5,
          text: this.$t("_BOOKING.STATUS.CLOSE"),
          color: "#262626"
        },
        {
          value: 6,
          text: this.$t("_BOOKING.STATUS.PAYMENT_FAILED"),
          color: "#ff0000"
        },
        {
          value: 7,
          text: this.$t("_BOOKING.STATUS.AWAIT_FULLY_PAYMENT"),
          color: "#fed12f"
        },
      ],
      listSelectOTA: [],
      listSelectHotel: [],
      selectedHotel: [],
      selectedOTA: [],
      paging: {
        searchBy: 'BOOKING_DATE',
        otaId: null,
        hotelId: null,
        lang: this.$i18n.locale
      },
      customerName: null,
      bookingReSync: null,
      listSearchPmsStatus: [
        {
          value: 1,
          text: this.$t("_DASHBOARD._HOTEL_STATUS_SYNC_PMS.RECEIVED")
        },
        {
          value: 0,
          text: this.$t("_DASHBOARD._HOTEL_STATUS_SYNC_PMS.NOT_RECEIVED")
        },
      ],
      listSearchPmsCode: [
        {
          value: 'ez_FOLIO',
          text: this.$t("ez_FOLIO")
        },
        {
          value: 'ez_CLOUDHOTEL',
          text: this.$t("ez_CLOUDHOTEL")
        },
        {
          value: '',
          text: this.$t("_DASHBOARD._HOTEL_STATUS_SYNC_PMS.UNSYNCHRONIZED")
        },
      ],
      selectedSearchPmsStatus: null,
      selectedSearchPmsCode: [],
      customerNameStay: null,
      customerPhone: null,
      hotelsData: [],
      listCheckinStatus: [
        {
          value: 0,
          text: this.$t("CHECKIN_STATUS_RESERVED")
        },
        {
          value: 1,
          text: this.$t("CHECKIN_STATUS_CHECKIN")
        },
        {
          value: 2,
          text: this.$t("CHECKIN_STATUS_CHECKOUT")
        },
        {
          value: 3,
          text: this.$t("CHECKIN_STATUS_NO_SHOW")
        },
        {
          value: 4,
          text: this.$t("CHECKIN_STATUS_ARRIVAL")
        },
        {
          value: 5,
          text: this.$t("CHECKIN_STATUS_DUE_OUT")
        },
        {
          value: 6,
          text: this.$t("CHECKIN_STATUS_CANCELLED")
        },
      ],
      selectedCheckinStatus: [],
      totals: {
        rooms: 0,
        nights: 0,
        bookings: 0,
        totalAdults: 0,
        totalChilds: 0,
        totalBabys: 0
      },
      bookingTravelAgent: [],
      bookingMarketSegment: [],
      colums: [
        {
          text: this.$t("_BOOKING.AGENT"),
          value: "agent",
        },
        {
          text: this.$t("_BOOKING.MARKET"),
          value: "market",
        },
        {
          text: this.$t("ROOM_TYPE"),
          value: "bookingLines_room",
        },
        {
          text: this.$t("SALE_PACKAGE"),
          value: "bookingLines_ratePlan",
        },
        {
          text: this.$t("PRICE"),
          value: "bookingLines_price",
        },
        {
          text: this.$t("ADULT"),
          value: "adult",
        },
        {
          text: this.$t("CHILDREN"),
          value: "child",
        },
        {
          text: this.$t("_BOOKING_DETAIL.ROOM.BABY"),
          value: "baby",
        },
        {
          text: this.$t("_BOOKING.CHECKIN_STATUS"),
          value: "checkinStatus",
        },
        {
          text: this.$t("NUMBER_ROOM"),
          value: "numRoom",
        },
        {
          text: this.$t("NUMBER_NIGHT"),
          value: "numNight",
        },
        {
          text: this.$t("CREATED_BY_ACCOUNT"),
          value: "createdByName",
        },
        {
          text: this.$t("_BOOKING.BOOKING_DATE"),
          value: "bookingDate",
        },
        {
          text: this.$t("_BOOKING_DETAIL.BOOKING_DETAIL.NOTE"),
          value: "comment",
        },
        {
          text: "UTM Source",
          value: "utmSource",
        },
        {
          text: "UTM Medium",
          value: "utmMedium",
        },
        {
          text: "UTM Campaign",
          value: "utmCampaign",
        },
        {
          text: "UTM Term",
          value: "utmTerm",
        },
        {
          text: "UTM Content",
          value: "utmContent",
        },
        {
          text: "Payment collect",
          value: "paymentCollectType",
        },
        {
          text: this.$t('_BOOKING_DETAIL.COMMISSION'),
          value: "commission",
        },
        {
          text: this.$t('_BOOKING_DETAIL.BEFORE_COMMISSION'),
          value: "priceBeforeCommission",
        },
        {
          text: this.$t('_BOOKING_DETAIL.AFTER_COMMISSION'),
          value: "priceAfterCommission",
        },
      ],
      columViews: [],
      fnReSync: false,
      selectedSearchRatePlan: [],
      listSearchRatePlans: [],
      selectedSearchRoomType: [],
      listSearchRoomTypes: [],
      createdByName: null,
      utmCode: null,
      agents: [],
      segments: [],
      showDetail: false,
      code: null,
      currentRoute: this.$route.path,
      isShowPopup: false,
      isScrollLeftDisabled: true,
      isScrollRightDisabled: false,
      conditionStayDate: null,
      bookingCodeSearch: '',
      isClear: false,
      listNameBKStatus: [],
      listNamePmsStt: [],
      listNameHotel: [],
      listNamePmsCode: [],
      conditionDateRange: [],
      conditionSearch: 'BOOKING_DATE',
      widthScroll: 0,
      widthContainer: 0,
      resizeObserver: null,
      isShowArrow: false
    };
  },
  watch: {
    selectedBookingStatus() {
      this.paging.status = this.selectedBookingStatus;
    },
    selectedSearchCondition() {
      this.paging.searchBy = this.selectedSearchCondition;
    },
    selectedOTA() {
      this.paging.otaId = this.selectedOTA;
    },
    selectedHotel() {
      this.paging.hotelId = this.selectedHotel;
    },
    dateRange() {
      this.paging.from = this.dateRange[0];
      this.paging.to = this.dateRange[1];
    },
    showDetail() {
      if(this.showDetail == false) {
        history.pushState(null, '', `${this.currentRoute}`);
      }
    },
    widthScroll() {
      if (this.widthScroll + 50 > this.widthContainer) {
          this.isShowArrow = true;
      } else {
          this.isShowArrow = false;
      }
    }
  },
  computed: {
    numberSearch() {
      var num = 0
      if (this.customerName) {
        num += 1;
      }
      if (this.selectedSearchPmsCode.length > 0) {
        num += 1;
      }
      if (this.selectedSearchPmsStatus !== null) {
        num += 1;
      }
      if (this.selectedBookingStatus.length > 0) {
        num += 1;
      }
      if (this.selectedCheckinStatus.length > 0) {
        num += 1;
      }
      if (this.customerNameStay) {
        num += 1;
      }
      if (this.customerPhone) {
        num += 1;
      }
      if (this.createdByName) {
        num += 1;
      }
      if (this.utmCode) {
        num += 1;
      }
      if (this.bookingMarketSegment.length > 0) {
        num += 1;
      }
      if (this.bookingTravelAgent.length > 0) {
        num += 1;
      }
      if (this.selectedSearchRatePlan.length > 0) {
        num += 1;
      }
      if (this.selectedSearchRoomType.length > 0) {
        num += 1;
      }
      return num
    }
  },
  created() {
    let searchHistoryGroup = sessionStorage.getItem('searchHistoryGroup');
    if (searchHistoryGroup) {
      searchHistoryGroup = JSON.parse(searchHistoryGroup);
      this.selectedSearchCondition = searchHistoryGroup.selectedSearchCondition;
      this.dateRange = [new Date(searchHistoryGroup.dateRange[0]), new Date(searchHistoryGroup.dateRange[1])];
      this.stayDate = new Date(searchHistoryGroup.stayDate);
      this.selectedOTA = searchHistoryGroup.selectedOTA;
      this.selectedHotel = searchHistoryGroup.selectedHotel;
      this.selectedBookingStatus = searchHistoryGroup.selectedBookingStatus;
      this.selectedSearchPmsStatus = searchHistoryGroup.selectedSearchPmsStatus;
      this.selectedSearchPmsCode = searchHistoryGroup.selectedSearchPmsCode;
      this.customerName = searchHistoryGroup.customerName;
      this.paging = searchHistoryGroup.paging;
      this.paging.offset = 0;
      if (searchHistoryGroup.selectedBookingStatus.length == 0) {
        this.paging.status = null;
      }
      this.customerPhone = searchHistoryGroup.customerPhone;
      this.customerNameStay = searchHistoryGroup.customerNameStay;
      this.bookingTravelAgent = searchHistoryGroup.bookingTravelAgent;
      this.bookingMarketSegment = searchHistoryGroup.bookingMarketSegment;
      this.selectedSearchRoomType = searchHistoryGroup.selectedSearchRoomType;
      this.selectedSearchRatePlan = searchHistoryGroup.selectedSearchRatePlan;
      this.createdByName = searchHistoryGroup.createdByName;
      this.utmCode = searchHistoryGroup.utmCode;
    } else {
      const today = new Date();
      today.setHours(0);
      today.setMinutes(0);
      today.setSeconds(0);
      const day1 = new Date(moment().add(1, 'day'));
      day1.setHours(0);
      day1.setMinutes(0);
      day1.setSeconds(0);
      this.dateRange = [today,day1];
      this.stayDate = new Date(moment().format('YYYY-MM-DD'));
    }
  },
  mounted() {
    this.initialize();
  },
  methods: {
    getAgents() {
      let body = {
        keyword: null,
        status: null,
        limit: 99999,
        offset: 0,
        orderBy: 'active',
        asc: false,
      };
      chainService.getAllTravelAgent(body).then(res => {
        this.agents = res.data;
      }).finally(() => (this.getSegments()));
    },
    getSegments() {
      chainService.getAllSegment().then(res => {
        this.segments = res.data;
      });
    },
    sumPeople(key, data) {
      return data.filter(e => e.bookingLineType === 0).map(i => i[`${key}`]).reduce(function (a, b) {
        return a + b;
      });
    },
    selectAllColum() {
      const arr = [...this.colums.filter(item => item.text.toString().toLowerCase().includes(this.textSearch.toLowerCase())).map(e => e.value)]
      this.columViews = JSON.parse(JSON.stringify(arr))
    },
    remove(index, array) {
      array.splice(index, 1);
      this.$forceUpdate();
    },
    totalNumber(array) {
      let result = array.reduce((a, b) => {
        return +a + +b;
      });
      return result;
    },
    showBookingOta(hotel, ota, isNextPage) {
      if (!ota.active || isNextPage) {
        ota.isLoading = true;
        const body = {
          limit: ota.paging.limit,
          offset: ota.paging.offset,
          lang: this.paging.lang,
          searchBy: this.paging.searchBy,
          from: this.paging.from,
          to: this.paging.to,
          code: this.paging.code,
          status: this.paging.status,
          otaIds: [ota.otaId],
          hotelIds: [hotel.hotelId],
          customerName: this.customerName,
          channelStatus: this.selectedSearchPmsStatus,
          guestName: this.customerNameStay,
          customerPhoneNumber: this.customerPhone,
          pmsCodes: this.selectedSearchPmsCode,
          checkinStatus: this.selectedCheckinStatus,
          exportDate: null,
          bookingTravelAgent: this.bookingTravelAgent,
          bookingMarketSegment: this.bookingMarketSegment,
          createdByName: this.createdByName,
          utmCode: this.utmCode,
          stayDate: moment(this.stayDate).format('YYYY-MM-DD')
        };
        chainService
          .getAllBookingsGroupByHotel(body)
          .then(res => {
            if (res.responseCode === 0) {
              ota.bookingData = res.data;
              ota.paging.total = res.total;
              ota.isLoading = false
            } else {
              ota.isLoading = false
              _alert(res, this.$t(res.data), false);
            }
            this.$forceUpdate();
          })
          .finally(() => (ota.isLoading = false));
      }
    },
    openPopupReSync(item) {
      this.bookingReSync = item
      this.$refs.reSyncDialogComponent.open(item)
    },
    reSync(item) {
      const body = {
        bookingCode: item.bookingCode
      };
      chainService.reSync(body).then(res => {
        _alert(res, this.$t(res.data), false);
      });
    },
    _formatDateTimeUTCToLocal(value, inputFormat, outputFormat) {
      if (!value) {
        return "";
      }
      return _formatDateTimeUTCToLocal(value, inputFormat, outputFormat);
    },
    _formatDateTime(value, inputFormat, outputFormat) {
      if (!value) {
        return "";
      }
      return moment(value).format(outputFormat);
    },
    calcTotalAmount(bookingLines) {
      let amount = 0;
      bookingLines.forEach(x => {
        amount = amount + x.amountPax;
      });
      return _formatCurrency(amount);
    },
    async initialize() {
      const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
      const userRole = currentUser.user.roles
        ? currentUser.user.roles.map(role => role.fnCode)
        : undefined;
      this.fnReSync = userRole.indexOf("CHAIN_BOOKING_REPOST") >= 0
      let body = {
        keyword: "",
        status: 1
      };
      await syncota.getAllOTAChain(body).then(res => {
        if (res.responseCode === 0) {
          res.data.forEach(x => {
            this.listSelectOTA.push({
              value: x.id,
              text: x.otaI18n.find(y => y.lang == this.defaultI18n).name
            });
          });
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });

      let chain = {
        keyword: "",
        status: 1,
        limit: 1000,
        offset: 0
      };

      await chainService
        .getHotelByChain(this.defaultI18n)
        .then(res => {
          if (res.responseCode === 0) {
            res.data.forEach(x => {
              this.listSelectHotel.push({
                value: x.id,
                text: x.name
              });
            });
            this.getAllRoomByChain();
          } else {
            _alert(res, this.$t(res.data), false);
          }
        });

      this.getAgents();
      this.getAll();
    },
    async getAllRoomByChain() {
      await chainService
        .getAllRoomTypeByChain()
        .then(res => {
          this.listSearchRoomTypes = [];
          if (res.responseCode === 0) {
            res.data.forEach(x => {
              this.listSearchRoomTypes.push({
                value: x.id,
                text: x.roomTypeI18n.find(e => e.lang === this.defaultI18n).name
              });
            });
            // this.selectedSearchRoomType = this.listSearchRoomTypes.map(e => e.value);
            this.getAllRatePlanByChain();
          } else {
            _alert(res, this.$t(res.data), false);
          }
        });
    },
    async getAllRatePlanByChain() {
      await chainService
        .getAllRatePlanByChain()
        .then(res => {
          this.listSearchRatePlans = [];
          if (res.responseCode === 0) {
            res.data.forEach(x => {
              this.listSearchRatePlans.push({
                value: x.id,
                text: x.ratePlanI18n.find(e => e.lang === this.defaultI18n).name
              });
            });
            // this.selectedSearchRatePlan = this.listSearchRatePlans.map(e => e.value);
          } else {
            _alert(res, this.$t(res.data), false);
          }
        });
    },
    formatCurrency: _formatCurrency,
    // Change page
    changePage(hotel, ota) {
      this.showBookingOta(hotel, ota, true);
      this.$forceUpdate();
    },
    // Reset
    reset() {
      this.selectedSearchCondition = 'BOOKING_DATE';
      const today = new Date();
      today.setHours(0);
      today.setMinutes(0);
      today.setSeconds(0);
      const day1 = new Date(moment().add(1, 'day'));
      day1.setHours(0);
      day1.setMinutes(0);
      day1.setSeconds(0);
      this.dateRange = [today,day1];
      this.selectedOTA = [];
      this.selectedBookingStatus = [];
      this.customerName = null;
      this.customerPhone = null;
      this.selectedSearchPmsStatus = null;
      this.bookingTravelAgent = [];
      this.bookingMarketSegment = [];
      this.selectedHotel = [];
      this.selectedSearchPmsCode = [];
      this.customerNameStay = null;
      this.createdByName = null;
      this.selectedSearchRoomType = [];
      this.selectedSearchRatePlan = []
      this.utmCode = null;
    },
    // Get all booking
    getAll(isSearching) {
      this.isClear = false;
      this.bookingCodeSearch = '';
      this.mapValuesOTA();
      this.mapValuesBKStatus();
      this.mapValuesPmsStt();
      this.mapValuesPmsCode();
      this.mapValuesHotel();
      this.mapValuesRoomType();
      this.mapValuesRatePlan();
      this.conditionStayDate = this.stayDate;
      this.conditionUtmCode = this.utmCode;
      this.conditionCustomerName = this.customerName;
      this.conditionCustomerPhone = this.customerPhone;
      this.conditionCustomerStay = this.customerNameStay;
      this.conditionCreatedByName = this.createdByName;
      this.conditionBookingTravelAgent = [...new Set(this.bookingTravelAgent)];
      this.conditionBookingSegments = [...new Set(this.bookingMarketSegment)];
      this.conditionDateRange = this.deepCopyArrayWithDates(this.dateRange);
      this.conditionSearch = this.selectedSearchCondition;
      this.isShowPopup = false;
      this.paging.searchBy = this.selectedSearchCondition;
      this.isClear = false;
      if (this.paging.searchBy === null || this.paging.searchBy === 'BOOKING_DATE' || this.paging.searchBy === 'CHECKIN_DATE' || this.paging.searchBy === 'CHECKOUT_DATE') {
        if (this.isSixMonthsOrLess(this.paging.from, this.paging.to) === 1) {
          _alert(null, this.$t("PLEASE_SELECT_DATE_LESS_6_MONTH"));
          return
        }
      }
      if ((this.paging.searchBy === 'BOOKING_CODE_OTA' || this.paging.searchBy === 'BOOKING_CODE') && !this.paging.code) {
        this.hotelsData = [];
        return
      }
      if (isSearching) this.paging.offset = 0;
      this.isLoading = true;
      const body = {
        limit: 15,
        offset: 0,
        lang: this.paging.lang,
        searchBy: this.paging.searchBy,
        from: this.paging.from,
        to: this.paging.to,
        code: this.paging.code,
        status: this.paging.status,
        otaIds: this.selectedOTA,
        hotelIds: this.selectedHotel,
        customerName: this.customerName,
        channelStatus: this.selectedSearchPmsStatus,
        guestName: this.customerNameStay,
        customerPhoneNumber: this.customerPhone,
        pmsCodes: this.selectedSearchPmsCode,
        checkinStatus: this.selectedCheckinStatus,
        exportDate: null,
        bookingTravelAgent: this.bookingTravelAgent,
        bookingMarketSegment: this.bookingMarketSegment,
        roomTypeIds: this.selectedSearchRoomType.length === 0 ? null : this.selectedSearchRoomType,
        ratePlanIds: this.selectedSearchRatePlan.length === 0 ? null : this.selectedSearchRatePlan,
        createdByName: this.createdByName,
        utmCode: this.utmCode,
        stayDate: moment(this.stayDate).format('YYYY-MM-DD')
      };
      this.totals = {
        rooms: 0,
        nights: 0,
        bookings: 0,
        totalAdults: 0,
        totalChilds: 0,
        totalBabys: 0
      }
      chainService
        .getTotalBookingsGroupByHotel(body)
        .then(res => {
          if (res.responseCode === 0) {
            // this.dataTable = res.data;
            this.hotelsData = res.data
            this.hotelsData.forEach(e => {
              e.groupByOTA.forEach(ota => {
                ota.active = false;
                ota.bookingData = [];
                ota.paging = {
                  total: ota.totalBookings,
                  limit: 15,
                  offset: 0
                };
                ota.isLoading = false;
                this.totals.rooms += ota.totalRooms;
                this.totals.nights += ota.totalNights;
                this.totals.bookings += ota.totalBookings;
                this.totals.totalAdults += ota.totalAdults;
                this.totals.totalChilds += ota.totalChilds;
                this.totals.totalBabys += ota.totalBabys;
              })
            })
          } else {
            _alert(res, this.$t(res.data), false);
          }
        })
        .finally(() => (this.isLoading = false));
        this.resizeObserver = new ResizeObserver(entries => {
          for (let entry of entries) {
              if (entry.target === this.$refs.scrollContainer) {
              this.widthScroll = entry.contentRect.width;
              } else if (entry.target === this.$refs.containerCondition) {
              this.widthContainer = entry.contentRect.width;
              }
          }
        });
        this.resizeObserver.observe(this.$refs.scrollContainer);
        this.resizeObserver.observe(this.$refs.containerCondition);
    },
    searchByCode() {
      this.conditionDateRange = [];
      this.listNameOTA = [];
      this.listNameHotel = [];
      this.listNameBKStatus = [];
      this.customerName = null;
      this.customerPhone = null;
      this.listNamePmsStt = null;
      this.selectedSearchPmsStatus = null;
      this.listNamePmsCode = [];
      this.customerNameStay = null;
      this.conditionCreatedByName = null;
      this.utmCode = null;
      this.conditionBookingTravelAgent = [];
      this.conditionBookingSegments = [];
      this.listNameRoomType = [];
      this.listNameRatePlane = [];
      this.conditionStayDate = null;
      this.totals.rooms = 0;
      this.totals.nights = 0;
      this.totals.bookings = 0;
      this.totals.totalAdults = 0;
      this.totals.totalChilds = 0;
      this.totals.totalBabys = 0;
      this.paging.searchBy = 'BOOKING_CODE_OTA';
      if (this.paging.searchBy === 'BOOKING_CODE_OTA' && !this.bookingCodeSearch) {
        this.hotelsData = [];
        return
      }
      this.isClear = true;
      this.isLoading = true;
      const body = {
        limit: 15,
        offset: 0,
        lang: this.paging.lang,
        searchBy: this.paging.searchBy,
        from: this.paging.from,
        to: this.paging.to,
        code: this.bookingCodeSearch,
        status: [],
        otaIds: [],
        hotelIds: [],
        customerName: null,
        channelStatus: null,
        guestName: null,
        customerPhoneNumber: null,
        pmsCodes: [],
        checkinStatus: [],
        exportDate: null,
        bookingTravelAgent: [],
        bookingMarketSegment: [],
        roomTypeIds: null,
        ratePlanIds: null,
        createdByName: null,
        utmCode: null,
        stayDate: null
      };
      this.totals = {
        rooms: 0,
        nights: 0,
        bookings: 0,
        totalAdults: 0,
        totalChilds: 0,
        totalBabys: 0
      }
      chainService
        .getTotalBookingsGroupByHotel(body)
        .then(res => {
          if (res.responseCode === 0) {
            // this.dataTable = res.data;
            this.hotelsData = res.data
            this.hotelsData.forEach(e => {
              e.groupByOTA.forEach(ota => {
                ota.active = false;
                ota.bookingData = [];
                ota.paging = {
                  total: ota.totalBookings,
                  limit: 15,
                  offset: 0
                };
                ota.isLoading = false;
                this.totals.rooms += ota.totalRooms;
                this.totals.nights += ota.totalNights;
                this.totals.bookings += ota.totalBookings;
                this.totals.totalAdults += ota.totalAdults;
                this.totals.totalChilds += ota.totalChilds;
                this.totals.totalBabys += ota.totalBabys;
              })
            })
          } else {
            _alert(res, this.$t(res.data), false);
          }
        })
        .finally(() => (this.isLoading = false));
    },
    // Go to booking detail page
    goToBookingDetail(code) {
      this.code = code;
      let searchHistoryGroup = {
        selectedSearchCondition: JSON.parse(JSON.stringify(this.selectedSearchCondition)),
        paging: JSON.parse(JSON.stringify(this.paging)),
        dateRange: JSON.parse(JSON.stringify(this.dateRange)),
        stayDate: JSON.parse(JSON.stringify(this.stayDate)),
        selectedOTA: JSON.parse(JSON.stringify(this.selectedOTA)),
        selectedHotel: JSON.parse(JSON.stringify(this.selectedHotel)),
        selectedBookingStatus: JSON.parse(JSON.stringify(this.selectedBookingStatus)),
        selectedSearchPmsStatus: JSON.parse(JSON.stringify(this.selectedSearchPmsStatus)),
        selectedSearchPmsCode: JSON.parse(JSON.stringify(this.selectedSearchPmsCode)),
        customerName: JSON.parse(JSON.stringify(this.customerName)),
        customerPhone: JSON.parse(JSON.stringify(this.customerPhone)),
        customerNameStay: JSON.parse(JSON.stringify(this.customerNameStay)),
        bookingTravelAgent: JSON.parse(JSON.stringify(this.bookingTravelAgent)),
        bookingMarketSegment: JSON.parse(JSON.stringify(this.bookingMarketSegment)),
        selectedSearchRoomType: JSON.parse(JSON.stringify(this.selectedSearchRoomType)),
        selectedSearchRatePlan: JSON.parse(JSON.stringify(this.selectedSearchRatePlan)),
        createdByName: JSON.parse(JSON.stringify(this.createdByName)),
        utmCode: JSON.parse(JSON.stringify(this.utmCode)),
      };
      sessionStorage.setItem('searchHistoryGroup', JSON.stringify(searchHistoryGroup));
      const routeInfo = this.$router.resolve({ 
        name: "groupBookingDetail",
        params: { code: code } 
      });
      history.pushState(null, '', routeInfo.href);
      this.showDetail = true;
    },
    // Export booking
    exportBooking() {
      this.isLoading = true;
      let param = {

        limit: 15,
        offset: 0,
        lang: this.paging.lang,
        searchBy: this.paging.searchBy,
        from: this.paging.from,
        to: this.paging.to,
        code: this.paging.code,
        status: this.paging.status,
        otaIds: this.selectedOTA,
        hotelIds: this.selectedHotel,
        customerName: this.customerName,
        channelStatus: this.selectedSearchPmsStatus,
        guestName: this.customerNameStay,
        customerPhoneNumber: this.customerPhone,
        pmsCodes: this.selectedSearchPmsCode,
        checkinStatus: this.selectedCheckinStatus,
        exportDate: moment(new Date()).format('YYYY-MM-DD_HH:mm:ss'),
        bookingTravelAgent: this.bookingTravelAgent,
        bookingMarketSegment: this.bookingMarketSegment,
        roomTypeIds: this.selectedSearchRoomType.length === 0 ? null : this.selectedSearchRoomType,
        ratePlanIds: this.selectedSearchRatePlan.length === 0 ? null : this.selectedSearchRatePlan,
        createdByName: this.createdByName,
        utmCode: this.utmCode,
        stayDate: moment(this.stayDate).format('YYYY-MM-DD')
      };
      chainService
        .exportExcelBookingGroupByHotel(param)
        .then(res => {
          if (res.responseCode === 0) {
            const url = res.data;
            FileSaver.saveAs(url);
          } else {
            _alert(res, this.$t(res.data), false);
          }
        })
        .finally(() => (this.isLoading = false));
    },
    exportBookingPdf() {
      this.isLoading = true;
      let param = {

        limit: 15,
        offset: 0,
        lang: this.paging.lang,
        searchBy: this.paging.searchBy,
        from: this.paging.from,
        to: this.paging.to,
        code: this.paging.code,
        status: this.paging.status,
        otaIds: this.selectedOTA,
        hotelIds: this.selectedHotel,
        customerName: this.customerName,
        channelStatus: this.selectedSearchPmsStatus,
        guestName: this.customerNameStay,
        customerPhoneNumber: this.customerPhone,
        pmsCodes: this.selectedSearchPmsCode,
        checkinStatus: this.selectedCheckinStatus,
        exportDate: moment(new Date()).format('YYYY-MM-DD_HH:mm:ss'),
        bookingTravelAgent: this.bookingTravelAgent,
        bookingMarketSegment: this.bookingMarketSegment,
        roomTypeIds: this.selectedSearchRoomType.length === 0 ? null : this.selectedSearchRoomType,
        ratePlanIds: this.selectedSearchRatePlan.length === 0 ? null : this.selectedSearchRatePlan,
        createdByName: this.createdByName,
        utmCode: this.utmCode,
        stayDate: moment(this.stayDate).format('YYYY-MM-DD')
      };
      chainService
        .exportPdfBookingGroupByHotel(param)
        .then(res => {
          if (res.responseCode === 0) {
            const url = res.data;
            FileSaver.saveAs(url);
          } else {
            _alert(res, this.$t(res.data), false);
          }
        })
        .finally(() => (this.isLoading = false));
    },
    openPopup() {
      this.isShowPopup = !this.isShowPopup;
    },
    scrollLeft() {
      const container = this.$refs.scrollContainer;
      container.scrollBy({
          left: -200,
          behavior: "smooth",
      });
    },
    scrollRight() {
      const container = this.$refs.scrollContainer;
      container.scrollBy({
          left: 200,
          behavior: "smooth",
      });
    },
    
    formatDate(condition, dateRage) {            
      var dateStart = moment(dateRage[0], "YYYY-MM-DD");
      var dateEnd = moment(dateRage[1], "YYYY-MM-DD");
      if (condition === 'BOOKING_DATE') {
          return dateStart.format("DD/MM/YYYY HH:mm:ss") + ' ~ ' + dateEnd.format("DD/MM/YYYY HH:mm:ss");
      } else if (condition === 'STAY_DATE') {                
          return moment(dateRage, "DD/MM/YYYY").format("DD/MM/YYYY");
      } else {
          return dateStart.format("DD/MM/YYYY")+ ' ~ ' + dateEnd.format("DD/MM/YYYY");
      }
    },
    mapValuesOTA() { 
      this.listNameOTA = this.selectedOTA.map(id => {
          const matchedItem = this.listSelectOTA.find(item => item.value === id); 
          return matchedItem ? matchedItem.text : null; 
      }).filter(item => item !== null)
    },
    mapValuesBKStatus() { 
      this.listNameBKStatus = this.selectedBookingStatus.map(id => {
          const matchedItem = this.listBookingStatus.find(item => item.value === id); 
          return matchedItem ? matchedItem.text : null; 
      }).filter(item => item !== null)
    },
    mapValuesHotel() { 
      this.listNameHotel = this.selectedHotel.map(id => {
          const matchedItem = this.listSelectHotel.find(item => item.value === id); 
          return matchedItem ? matchedItem.text : null; 
      }).filter(item => item !== null)
    },
    mapValuesPmsStt() {
      this.listNamePmsStt = this.listSearchPmsStatus.find(item => item.value === this.selectedSearchPmsStatus);      
    },
    mapValuesPmsCode() {
      this.listNamePmsCode = this.selectedSearchPmsCode.map(id => {
        const matchedItem = this.listSearchPmsCode.find(item => item.value === id); 
        return matchedItem ? matchedItem.text : null; 
      })
    },
    mapValuesRoomType() {
      this.listNameRoomType = this.selectedSearchRoomType.map(id => {
        const matchedItem = this.listSearchRoomTypes.find(item => item.value === id); 
        return matchedItem ? matchedItem.text : null; 
      })
    },
    mapValuesRatePlan() {
      this.listNameRatePlane = this.selectedSearchRatePlan.map(id => {
        const matchedItem = this.listSearchRatePlans.find(item => item.value === id); 
        return matchedItem ? matchedItem.text : null; 
      })
    },
    _moment: moment
  }
};
</script>
<style scoped>
.popup-content {
  height: 500px;
  overflow-x: scroll;
  overflow-x: hidden;
  padding-right: 10px;
}
</style>